<div class="diver"></div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .diver {
    height: 10px;
    margin: 0 -16px;
    background: $neutral-light-04;
    box-shadow:
      inset 0px -1px 1px rgba(0, 0, 0, 0.04),
      inset 0px 1px 1px rgba(0, 0, 0, 0.04);
    @include desktop-min-width {
      height: 20px;
      margin: 0 -48px;
    }
  }
</style>
